<template lang="pug">
.chairman-box(:class="$style.wrapper")
  div(:class="$style.left")
    figure(:class="$style.photo")
      img(:src="photo")
  div(:class="$style.right")
    .title.is-5(:class="$style.item") {{ name }}
    b-tag(:class="$style.item"
      type="is-primary"
      size="is-medium") {{ job }}
    b-taglist(:class="$style.item"
      attached)
      b-tag(type="is-dark"
        size="is-small") 故鄉
      b-tag(type="is-info"
        size="is-small") {{ homeland }}
</template>

<script>
export default {
  name: "ChairmanBox",
  props: {
    photo: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    job: {
      type: String,
      default: "",
    },
    homeland: {
      type: String,
      default: "",
    },
  },
};
</script>

<style module lang="sass">
.wrapper
  +flexbox(flex-start, center)
  +wrap
  position: relative
  padding-bottom: pxRem(36)
  +xs
    +flexbox(flex-start, center, column)
  .left
    flex: 0 0 30%
    min-width: 128px
    max-width: 154px
    .photo
      +ratioImage(1, 1)
      width: 100%
      img
        +size(100%, 100%)
        +rounded
  .right
    flex: 1 0
    min-width: pxRem(180)
    padding: 0 5%
    .item
      margin: pxRem(12) 0
      font-weight: bold
    +xs
      +flexbox(center, center, column)
      padding-top: pxRem(18)
</style>
